
import React from 'react';

const SuccessIcon2 = props => (
    <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="20" cy="20.5" r="20" fill="#16B862" />
        <path d="M12.7607 20.3744L17.8769 26.4717L26.8826 15.0187" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);

export default SuccessIcon2;